"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBatteryLevel = exports.getFillLevelColour = exports.capitalizeFirstLetter = exports.getItemValue = exports.defaultFormProps = exports.createPrefixer = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var createPrefixer_1 = require("./createPrefixer");
Object.defineProperty(exports, "createPrefixer", { enumerable: true, get: function () { return createPrefixer_1.createPrefixer; } });
// eslint-disable-next-line import/prefer-default-export
exports.defaultFormProps = {
    validateOnBlur: false,
    mutation: function (values) {
        return new Promise(function (resolve) { return setTimeout(function () { return resolve(values); }, 3000); });
    },
    mutationVariablesFormatter: function (values) {
        return { fullName: values.firstName + " " + values.lastName };
    },
    validate: function (values) {
        var error = {};
        if (!values.firstName) {
            error.firstName = "Required field!";
        }
        if (!values.lastName) {
            error.lastName = "Required field!";
        }
        return error;
    },
    onSubmitCallback: function (response) { return console.log(JSON.stringify(response)); },
};
var getItemValue = function (value) { return value || "-"; };
exports.getItemValue = getItemValue;
var capitalizeFirstLetter = function (s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var getFillLevelColour = function (fl) {
    var fillLevel = 0;
    var color = "#000000";
    switch (true) {
        case fl > 100:
            fillLevel = 100;
            break;
        case fl < 0:
            fillLevel = 100;
            break;
        default:
            fillLevel = Math.round(fl);
            break;
    }
    switch (true) {
        case fillLevel <= 15 && fillLevel >= 0:
            color = "#9BD383";
            break;
        case fillLevel <= 75 && fillLevel >= 16:
            color = "#FDD569";
            break;
        case fillLevel <= 95 && fillLevel >= 76:
            color = "#FF7B75";
            break;
        case fillLevel <= 100 && fillLevel >= 96:
            color = "#E72100";
            break;
        default:
            color = "#000000";
            break;
    }
    return color;
};
exports.getFillLevelColour = getFillLevelColour;
var getBatteryLevel = function (bl) {
    if (bl > 100)
        return 100;
    return bl;
};
exports.getBatteryLevel = getBatteryLevel;
